import { useTranslation } from 'react-i18next';

import Typography from '~/components/Typography';
import type { FontSizes } from '~/interfaces/font_family';

interface Props {
  nextPage: () => void;
  text?: string;
  fontFamily: string;
  fontSize?: FontSizes;
  color?: string;
}

const NextPageButton = ({ text, nextPage, fontFamily, fontSize, color }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="flex w-full justify-center">
      <button onClick={nextPage} className="pb-4">
        <Typography
          as="span"
          fontFamily={fontFamily}
          size={fontSize}
          color={color}
          className="extra-light mb-4 whitespace-nowrap text-sm underline underline-offset-1"
        >
          {text || t('shared.cta.maybe_later')}
        </Typography>
      </button>
    </div>
  );
};

export default NextPageButton;
